<template>
<div style="height: 100%;">
    <router-view/>
    <van-tabbar v-model="active" :placeholder="true" :safe-area-inset-bottom="true">
        <van-tabbar-item replace to="/newmanager" icon="bar-chart-o">
            <span>业绩</span>
        </van-tabbar-item>
        <van-tabbar-item replace to="/hairhl" icon="manager-o">
            <span>护理客勤</span>
        </van-tabbar-item>
        <van-tabbar-item replace to="/hairdata" icon="chart-trending-o">
            <span>美发数据</span>
        </van-tabbar-item>
        <van-tabbar-item replace to="/hairjx" icon="orders-o">
            <span>美发绩效</span>
        </van-tabbar-item>
    </van-tabbar>
</div>
</template>
<script>
    export default {
        data(){
            return {
                active:0,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/managertabbar.vue